import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import downArrow from "../assets/arrow_down_home.svg";
import hamburger from "../assets/hamburger.svg";
import logoWhite from "../assets/logo/logo_white.svg";
import MobileMenu2 from "./MobileMenu2";
import icons1 from "./SubIcons/icons1.svg";
import icons2 from "./SubIcons/icons2.svg";
import icons3 from "./SubIcons/icons3.svg";
import icons4 from "./SubIcons/icons4.svg";

const Header = () => {
  const Menu = [
    {
      id: "1",
      name: "How it works",
      to: "/howitwork",
      submenu: [],
    },
    {
      id: "2",
      name: "Customers",
      to: "/",
      submenu: [
        {
          leftItem: [
            {
              icon: icons1,
              title: "Individuals",
              to: "/individuals",
              para: "Learn about how individuals use wecanrush for their everyday pickups and deliveries",
            },
            {
              icon: icons2,
              iconTitle: "",
              title: "Businesses",
              to: "/business",
              para: "Learn about how businesses use wecanrush as their trusted logistics partner.",
            },
          ],
          leftTitle: "WECANRUSH FOR",
          rightTitle: "LOCATIONS",
          rightItem: [
            {
              link: "Indianapolis",
              addr: "",
            },
            {
              link: "Fort Wayne",
              addr: "",
            },
            {
              link: "Louisville",
              addr: "",
            },
            {
              link: "Cincinnati",
              addr: "",
            },
            {
              link: "Columbus",
              addr: "",
            },
          ],
        },
      ],
    },
    {
      id: "3",
      name: "Drivers",
      to: "/drivers",
      submenu: [],
    },
    {
      id: "4",
      name: "Industries",
      to: "/industries",
      submenu: [],
    },
    {
      id: "5",
      name: "Resources",
      to: "/",
      submenu: [
        {
          leftItem: [
            {
              icon: icons3,
              iconTitle: "",
              title: "Blog",
              to: "/blog",
              para: "Get started with tips and information about how wecanrush operates.",
            },
            {
              icon: icons4,
              title: "Help Desk",
              to: "https://wecanrush.zendesk.com/",
              para: "Need to talk to someone on our team about anything, Find us here.",
            },
          ],
          leftTitle: "RESOURCES",
          rightTitle: "OTHERS",
          rightItem: [
            {
              link: "FAQs",
              addr: "/faq",
            },
            {
              link: "Track your item",
              addr: "/howitwork",
            },
            {
              link: "About ",
              addr: "/about",
            },
            {
              link: "Contact",
              addr: "/contactus",
            },
          ],
        },
      ],
    },
  ];

  return (
    <Wrapper style={{ background: "#6300ff" }}>
      <div className=" section-center text-center header">
        <Link to="/">
          <div className="header__logo">
            <img src={logoWhite} alt="logo" />
          </div>
        </Link>

        <div className="main_navbar">
          <div className="d_header">
            <ul className="d_header_ul">
              {Menu.map((items, id) => {
                return (
                  <>
                    <li key={id} className="d_header_list">
                      <Link to={items.to} className="header_list_item">
                        {items.name}
                        <i></i>
                        {items.submenu.map(() => (
                          <img src={downArrow} alt="logo" />
                        ))}
                      </Link>

                      {items.submenu.map((item, num) => (
                        <div key={num} className="d_sub_header_wrapper">
                          <div className="d_sub_header_left_container">
                            <h3>{item.leftTitle}</h3>
                            {item.leftItem.map((lItem, ind) => (
                              <div
                                key={ind}
                                className="d_sub_header_left_content"
                              >
                                <div className="left_content_header">
                                  <i className="icon">
                                    <img
                                      src={lItem.icon}
                                      alt={lItem.iconTitle}
                                    />
                                  </i>
                                  <Link
                                    onClick={() =>
                                      window.open(`${lItem.to}`, "_blank")
                                    }
                                  >
                                    <h2>{lItem.title}</h2>
                                  </Link>
                                </div>
                                <p>{lItem.para}</p>
                              </div>
                            ))}
                          </div>
                          <div className="d_sub_header_wright_container">
                            <h3>{item.rightTitle}</h3>
                            <ul className="d_sub_header_wright_ul">
                              {item.rightItem.map((rItem, ind) => (
                                <li key={ind}>
                                  <Link
                                    to={rItem.addr}
                                    key="{ind} to={items.to}"
                                    className="d_sub_header_list_item"
                                  >
                                    {rItem.link}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </li>
                  </>
                );
              })}
            </ul>
          </div>
          <div className="m_header">
            <MobileMenu2 />
          </div>
        </div>

        <div className="hamburger__menu">
          <img src={hamburger} alt="hamburger" />
        </div>

        <div className="navBar__btn">
          <Link
            onClick={() =>
              window.open("https://app.wecanrush.com/login", "_blank")
            }
          >
            <button className="header__first__btn">Login</button>
          </Link>

          <Link
            onClick={() =>
              window.open("https://app.wecanrush.com/register", "_blank")
            }
          >
            <button className="header__sececond__btn">
              Create a free account
            </button>
          </Link>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .header__logo {
    width: 130px;
    height: 35px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 100px;
    align-items: center;
    position: relative;
  }
  .m_header {
    display: none;
  }
  .main_navbar {
    position: relative;
  }
  ul.d_header_ul {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  li.d_header_list {
    margin: 0;
    font-family: Gilroy-Medium;
    font-size: 15px;
    line-height: 16px;
    text-align: center;
    color: #1e266d;
  }

  a.header_list_item {
    text-decoration: none;
    padding: 42px 20px;
    position: relative;
    color: #fff;
  }

  a.header_list_item img {
    padding-left: 10px;
  }

  a.d_sub_header_list_item {
    text-decoration: none;
    padding: 0px 20px;
    position: relative;
    color: #6d7d93;
  }

  /* sub menu */

  .d_sub_header_wrapper {
    display: none;
    width: 535px;
    min-height: 319px;
    z-index: 99999;
    position: absolute;
    left: 22px;
    justify-content: center;
    top: 59px;
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(245, 245, 245, 0.25);
    border-radius: 10px;
    text-align: left;
  }

  .d_sub_header_left_container {
    width: 335px;
    border-radius: initial;
    padding: 28px 28px 28px 43px;
  }

  .d_sub_header_left_container h3 {
    font-family: Gilroy-Bold;
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 37px;
    color: #6d7d93;
    text-align: left;
  }

  .d_sub_header_left_content {
    margin-bottom: 50px;
  }
  .d_sub_header_left_content .left_content_header {
    display: flex;
    align-items: center;
    height: 20px;
  }

  .d_sub_header_left_content .left_content_header h2 {
    font-family: Gilroy-Bold;
    font-size: 16px;
    margin: 10px 0 10px 14px;
    color: #545777;
  }

  .d_sub_header_left_content p {
    font-family: Gilroy-Medium;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #6d7d93;
    margin-top: 13px;
  }

  .d_sub_header_left_content .left_content_header i.icon {
    height: 20px;
    width: 20px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    background: #e5edfc;
    justify-content: center;
  }

  ul.d_sub_header_wright_ul {
    margin-top: 20px;
  }

  .d_sub_header_wright_container {
    width: 200px;
    background: #eef4fd;
    padding: 28px 0;
    background: linear-gradient(
      180deg,
      #e5edfc 0%,
      rgba(229, 237, 252, 0) 100%
    );
    border-radius: 0px 10px 10px 0px;
  }

  .d_sub_header_wright_container h3 {
    font-family: Gilroy-Bold;
    font-size: 12px;
    line-height: 14px;
    color: #6d7d93;
    padding-left: 15px;
    text-align: left;
  }
  .d_sub_header_wright_ul li {
    font-family: Gilroy-Medium;
    font-size: 14px;
    line-height: 34px;
    letter-spacing: 0px;
    text-align: left;
  }

  li.d_header_list:hover .d_sub_header_wrapper {
    display: flex;
  }

  li.d_header_list:hover a i {
    position: absolute;
    left: 5px;
    width: 95%;
    display: block;
    bottom: 10px;
    height: 3px;
    border-radius: 3px;
    background: #fff;
  }

  li.sub_list {
    background: black;
    padding: 12px 10px;
    width: 103px;
  }

  .hamburger__menu {
    display: none;
  }

  button.header__sececond__btn {
    width: 196px;
    height: 48px;
    font-family: Gilroy-Bold;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
    border: 1px solid #ffffff;
    box-sizing: border-box;
    border-radius: 5px;
    background: transparent;
  }

  button.header__sececond__btn:hover {
    background: #fff;
    transition: 0.5s;
    color: #6300ff;
  }

  .header__first__btn {
    border: none;
    outline: none;
    width: 100px;
    height: 48px;
    border-radius: 5px;
    margin-right: 10px;
    background: transparent;

    font-family: Gilroy-Medium;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height */

    color: #ffffff;
  }

  @media screen and (max-width: 768px) {
    .signup__mobile__btn {
      display: flex;
      align-items: center;
    }
    .navBar__btn,
    .d_header {
      display: none;
    }

    button.header__sececond__btn {
      background: linear-gradient(
        110.57deg,
        rgba(229, 237, 252, 0.1) -2.17%,
        #e5edfc 99.02%
      );
      border: 1px solid #1d66ff;
      box-sizing: border-box;
      border-radius: 5px;
      width: 196px;
      height: 48px;
      font-family: Gilroy-Bold;
      font-size: 14px;
      line-height: 16px;
      color: #1d66ff;
      margin-left: 10px;
    }

    .header__first__btn {
      font-family: Gilroy-Medium;
      font-size: 14px;
      line-height: 16px;
      border: none;
      outline: none;
      width: 80px;
      height: 48px;
      color: #1e266d;
      border-radius: 5px;
      margin-right: 10px;
      background: transparent;
    }

    .hamburger__menu {
      display: block;
    }
    .header {
      width: 90%;
    }
    .m_header {
      display: flex;
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      background: #fff;
      z-index: 10;
      flex-direction: column;
    }
    .m__header__container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 30px 0px;
      background: #6300ff;
    }

    .m_logo {
      margin-left: 20px;
      width: 130px;
      height: 35px;
    }

    .m_close {
      margin-right: 30px;
      cursor: pointer;
    }

    ul.m_header_ul {
      width: 100%;
      text-align: left;
    }

    a.m_header_list_item {
      text-decoration: none;
      padding: 0px 20px;
      position: relative;
      display: flex;
      justify-content: space-between;
      margin: 20px 0;
      color: #1e266d;
    }

    li.MenuItemBack {
      list-style: none;
    }

    li.MenuItemBack a {
      font-family: Gilroy-Medium;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: center;
      display: block;
      text-align: left;
      color: #6d7d93;
      margin-top: 20px;
    }

    li.MenuItemBack a img {
      margin-right: 10px;
    }
    .header {
      height: auto;
      width: 100% !important;
      overflow-x: hidden !important;
    }

    /* sub menu */

    .m_deader_fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background: #fff;
    }

    .m_sub_header_wrapper {
      width: 100%;
      z-index: 99;
      background: #ffffff;
      text-align: left;
    }

    .m_sub_header_left_container {
      width: 100%;
      padding: 35px 0 0 40px;
    }

    .m_sub_header_left_container h3 {
      font-family: Gilroy-Bold;
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 35px;
      color: #6d7d93;
      text-align: left;
    }

    .m_sub_header_left_content {
      margin-bottom: 50px;
    }

    .m_sub_header_left_content .left_content_header {
      display: flex;
      align-items: center;
      height: 20px;
    }

    .m_sub_header_left_content .left_content_header h2 {
      font-family: Gilroy-Bold;
      font-size: 16px;
      margin: -12px 0 10px 14px;
      color: #545777;
    }

    .m_sub_header_left_content p {
      font-family: Gilroy-Medium;
      font-size: 12px;
      max-width: 90%;
      line-height: 12px;
      letter-spacing: 0em;
      text-align: left;
      color: #6d7d93;
      margin-top: 10px;
    }

    .m_sub_header_left_content .left_content_header i.icon {
      height: 20px;
      width: 20px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      background: #e5edfc;
      justify-content: center;
    }

    .m_sub_header_wright_container {
      width: 100%;
      background: #eef4fd;
      padding: 65px 0 28px 0;
      background: linear-gradient(
        180deg,
        #e5edfc 0%,
        rgba(229, 237, 252, 0) 100%
      );
      border-radius: 0px 10px 10px 0px;
    }

    .m_sub_header_wright_container h3 {
      font-family: Gilroy-Bold;
      font-size: 12px;
      line-height: 14px;
      color: #6d7d93;
      margin-left: 35px;
      text-align: left;
      margin-bottom: 20px;
    }
    .m_sub_header_wright_ul li {
      font-family: Gilroy-Medium;
      font-size: 16px;
      line-height: 34px;
      letter-spacing: 0px;
      text-align: left;
      margin-left: 20px;
    }

    li.sub_list {
      background: black;
      padding: 12px 10px;
      width: 103px;
    }

    margin-top: 40px;
  }

  .m_header_list {
    padding-bottom: 8px;
  }
`;
export default Header;
